import { useLayoutEffect, useRef, useState } from "react";
import ItemsTooltip from "~/molecules/ItemsTooltip";
import MoreTooltip from "~/molecules/MoreTooltip";
import { TagsValue } from "~/molecules/Tags";

export function DocumentTagsCell({ titles }: { titles: string[] }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const measurementRef = useRef<HTMLDivElement>(null);
  const [visibleCount, setVisibleCount] = useState(1);

  useLayoutEffect(() => {
    const container = containerRef.current;
    const measurement = measurementRef.current;
    if (!container || !measurement) return;

    const measure = () => {
      const badges = measurement.querySelectorAll<HTMLElement>("[data-tag]");
      const counters =
        measurement.querySelectorAll<HTMLElement>("[data-count]");
      const gap = parseFloat(getComputedStyle(container).columnGap) || 0;
      const width = container.clientWidth;
      let used = 0;
      let count = 1;

      badges.forEach((badge, index) => {
        used += badge.getBoundingClientRect().width + (index > 0 ? gap : 0);
        const counterWidth =
          counters[index]?.getBoundingClientRect().width ?? 0;
        const required = used + (counterWidth > 0 ? gap + counterWidth : 0);
        if (required <= width) count = index + 1;
      });
      setVisibleCount(count);
    };

    const observer = new ResizeObserver(measure);
    observer.observe(container);
    observer.observe(measurement);
    measure();
    return () => observer.disconnect();
  }, [titles]);

  if (titles.length === 0) return "-";

  return (
    <div
      ref={containerRef}
      className="relative flex min-w-0 items-center gap-1 overflow-hidden"
    >
      {titles.slice(0, visibleCount).map((title, index) => (
        <ItemsTooltip key={index} items={[title]} variant="tag">
          <TagsValue className="min-w-0 shrink">
            <span className="truncate">{title}</span>
          </TagsValue>
        </ItemsTooltip>
      ))}
      <MoreTooltip data={titles} variant="tag" visibleCount={visibleCount} />
      <div
        ref={measurementRef}
        aria-hidden="true"
        className="pointer-events-none invisible absolute flex w-max gap-1"
      >
        {titles.map((title, index) => (
          <TagsValue key={index} data-tag>
            {title}
          </TagsValue>
        ))}
        {titles.slice(1).map((_, index) => (
          <span key={index} data-count>
            <MoreTooltip data={titles} variant="tag" visibleCount={index + 1} />
          </span>
        ))}
      </div>
    </div>
  );
}
